export default __webpack_public_path__ + "static/media/About-Us.c933f1e4.jpg";